// extracted by mini-css-extract-plugin
export default {"prize":"prize_prize__VybsA"};